import { styled } from '@mui/material/styles';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids/DatagridConfigurableWithStickyActions/DatagridConfigurableWithStickyActions';
import { ChipField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

const columnStyle120 = getColumnStyle(120);
const shrinkColumnStyle = { width: 0 };

export const StyledDatagrid = styled(DatagridConfigurableWithStickyActions)({
  '& .column-alias': shrinkColumnStyle,
  '& .column-archive': shrinkColumnStyle,
  '& .column-partner': shrinkColumnStyle,
  '& .column-platform': shrinkColumnStyle,
  '& .column-notificationKey': shrinkColumnStyle,
  '& .column-missmatchChatId': getColumnStyle(200),
  '& .column-language': shrinkColumnStyle,
  '& .column-referrals': shrinkColumnStyle,
  '& .column-companies': shrinkColumnStyle,
  '& .column-createdAt': columnStyle120,
  '& .column-updatedAt': columnStyle120,
});

export const ChipFieldStyled = styled(ChipField)({
  '.MuiChip-label': {
    color: '#FFF',
    cursor: 'pointer',
    lineHeight: '12px',
    textWrap: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '184px',
  },
});
